/*
 *  -----------------------------------------------------------------------
 *    <copyright file="admin-site-dashboard.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import AdminDashboard from './admin-dashboard';
import { DashboardType } from 'types/graphql-global-types';

const AdminSiteDashboard = ({ study }: any) => <AdminDashboard study={study} type={DashboardType.SITE} />;

export default AdminSiteDashboard;
